import { Navigate, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "../../contexts/AuthContext";
import { useContext } from "react";

const getManagerFromToken = (token) => {

    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return decoded.user_id;
    } catch (error) {
        return null;
    }
};

const ProtectedRouteWithManagerCheck = ({ children }) => {
    const { manager_id } = useParams();
    const { jwtToken } = useContext(AuthContext);
    const actualManagerId = getManagerFromToken(jwtToken);

    if (!actualManagerId) {
        console.log("User not authenticated or token invalid");
        return <Navigate to="/unauthorized" replace />;
    }

    if (parseInt(manager_id) !== actualManagerId) {
        console.log("User ID mismatch: Access denied");
        console.log(`Expected: ${manager_id}, Actual: ${actualManagerId}`);
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRouteWithManagerCheck;
